"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useService = useService;
exports.registerService = registerService;
exports.getService = getService;

var _react = require("react");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var factories = new Map(); // hold a function service

var services = new Map(); // hold an instance of a function service

var notifies = new Map(); // hold setState of component which use a service

function initService(id) {
  var instance = services.get(id);

  if (!instance) {
    var notify = function notify() {
      (notifies.get(id) || []).forEach(function (callMe) {
        return callMe(Object.assign({}, services.get(id)));
      });
    }; // this will call every setState to update each components


    var factory = factories.get(id);
    instance = _construct(factory.fn, [notify].concat(_toConsumableArray(factory.dependencies.map(initService))));
    services.set(id, instance);
  }

  return instance;
}
/**
 * useService let you get instance of a registred service
 * @param {string} id - the id of the service you want to get
 * @param {Object} options - to configure the behavior you want
 * @param {boolean} options.subscribe - set to false to not be notified of updates
 */


function useService(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    subscribe: true
  };

  var _useState = (0, _react.useState)(services.get(id)),
      _useState2 = _slicedToArray(_useState, 2),
      setState = _useState2[1];

  (0, _react.useEffect)(function () {
    return function cleanup() {
      if (notifies.get(id).has(setState)) {
        notifies.get(id).delete(setState);
      }
    };
  }, []);

  if (options.subscribe) {
    if (notifies.get(id) === undefined) {
      notifies.set(id, new Set([setState]));
    } else if (!notifies.get(id).has(setState)) {
      notifies.get(id).add(setState);
    }
  }

  return initService(id);
}
/**
 * registerService let you register a function and map it to an id.
 * @param {string|function} idOrFn - the id of the service you want to get or the function constructor identifed
 * @param {function} value - the function constructor of the service
 */


function registerService(idOrFn, value) {
  var id = idOrFn;
  var fn = value;

  if (!value) {
    id = idOrFn.$id;
    fn = idOrFn;
  }

  if (factories.get(id)) {
    throw new Error("A service is already registred under the key ".concat(id));
  } else {
    factories.set(id, {
      fn: fn,
      dependencies: fn.dependencies || []
    });
  }
}
/**
 * low level use of service (in case you are not in a component)
 * @param {string} id - the id of the service you want
 */


function getService(id) {
  return services.get(id);
}